module.exports = __webpack_public_path__ + "static/media/JiLin 1.a50e0a92.czml";